module.exports = __webpack_public_path__ + "img/signature.2fc555b8.svg";